import React, { useEffect, useState, useRef } from 'react';
import { Modal, Row, Col } from 'antd';
import { loadMeasurers, getMeasurers, round, DownloadCSV, isHasNormailzed } from '../../helpers/helpers';
import References from '../../helpers/Reference'
import { Radio, Button} from 'antd';
import iconv from 'iconv-lite';
import { Buffer } from 'buffer';
import { ExportModalWindow } from './components/export-modal-window';
import { GetExportFileName } from './utils';

const prepareValue = ( value, prec, decSep) => {    
    if (!isNaN(parseInt(value))) {  
        value = value.toFixed(prec).toString();
        value = decSep === ',' ? value.replace(/\./, ",") : value.replace(/\,/, ".")                                        
    } else 
        value = '';
    return value;
}

export const ExportChartData = ({start, finish, station, measurer, normalizeMethod, settings, onClose}) => {

    const [ isOpen, setIsOpen ] = useState( true );

    const onFinish = () => {
        setIsOpen( false );
        onClose();
    }

    const onExport =  (encoding, sep, decSep) => {
        const measurerRef = References.mchs[measurer.type]
        const unit = measurerRef.unit;
        const prec = measurerRef.precision;

        //может быть доп. поле (направление ветра, интенсивность осадков и т.д.)
        const hasExtInfo = measurerRef.hasOwnProperty('extInfo') ? true : false;

        //присутсвует нормализация
        const isNormalized = isHasNormailzed( normalizeMethod, measurer.type );

        //я не смог через charcode сделать так, чтобы был корректный разделитель, пришлось хардкодить
        const colSep = sep === "59" ? ";" : "\t";

        //шапка таблицы
        const measurerName = `${GetExportFileName(measurer, station, settings, 'column_name')}`;

        let csv = '';        
        csv += `${References.dictionary.time}${colSep}${measurerName}, ${unit}`;
        //дополнтильеные измерения
        if (hasExtInfo)
            csv += `${colSep}${measurerRef?.extInfoName}, ${measurerRef?.extInfoUnit}`
        //присутствует нормализация
        if (isNormalized) 
            csv += `${colSep}${measurerName}, ${unit} (norm)${colSep}${measurerName}, ${unit} (del)${colSep}${measurerName}, ${unit} (add)`

        csv += '\n';

        //основные данные
        loadMeasurers(measurer.uuid, 'mchs', measurer.type, start, finish, settings, normalizeMethod)
        .then((data) => {
            const preparedData = getMeasurers(data, measurer.uuid, 'mchs', measurer.type, settings);
            const amount = preparedData.data.length;

            for (let i = 0; i < amount; i++) {                
                csv += `${preparedData.labels[i]}${colSep}${prepareValue(preparedData.data[i], prec, decSep)}`;

                //забираем и преобразуем значение доп. поля
                if (hasExtInfo) {
                    let extValue = preparedData.source[i][measurerRef?.extInfoField];
                    if (extValue)
                        csv += `${colSep}${measurerRef.extInfoCalc(extValue)}`;
                }
                //если нормалидованные данные, то будут еще столбцы с исправленными удаленными данными
                if (isNormalized) {     
                    csv += `${colSep}${prepareValue(preparedData.data_norm[i], prec, decSep)}`;               

                    const addValue = preparedData.data_add.filter(val => val.time === preparedData.labels[i]);
                    if (addValue.length > 0)
                        csv += `${colSep}${prepareValue(addValue[0].value, prec, decSep)}`;

                    const delValue = preparedData.data_del.filter(val => val.time === preparedData.labels[i]);
                    if (addValue.length > 0)                    
                        csv += `${colSep}${prepareValue(delValue[0].value, prec, decSep)}`;
                }    

                csv += `\n`;
            }

            if (encoding === 'windows-1251') { 
                csv = iconv.encode(csv, "cp1251", {    
                    stripBOM: true,
                    addBOM: true,
                    defaultEncoding: 'win1251'}
                );
            }
            DownloadCSV( csv, GetExportFileName(measurer, station, settings, 'file_name'), encoding, onFinish );
        }); 
    }


    return (
        <ExportModalWindow onExport={onExport} opened={isOpen} onCancel={onFinish}/>
    );
}
